import { useState, useEffect, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { useIntl } from 'gatsby-plugin-react-intl';
import { navigate } from 'gatsby';
import sanitizeHtml from 'sanitize-html';

import SearchBar from '../../../Core/SearchBar';
import Link from '../../../Core/Link';
import { SearchContext } from '../../../Providers/SearchIndex';
import { useLunr } from '../../../../hooks';

import { PredictiveSearchContainer } from './styles';

const withFAQSearch = SearchInput => {
  const FAQSearch = ({
    className = '',
    predictiveSearchClass = null,
    predictiveSearch = false,
    type = '',
    placeholder = null,
  }) => {
    const [open, setOpen] = useState(false);
    const { lunrjs } = useContext(SearchContext);
    const [query, setQuery] = useState(``);
    const intl = useIntl();
    const [index, setIndex] = useState({});
    const [store, setStore] = useState({});

    useEffect(() => {
      if (lunrjs[intl.locale].index) {
        setIndex(JSON.parse(lunrjs[intl.locale].index));
      }
      if (lunrjs[intl.locale].store) {
        setStore(lunrjs[intl.locale].store);
      }
    }, [lunrjs]);

    const results = useLunr(query, index, store).filter(
      ({ category }) => category === 'FAQsCategory',
    );

    const formSubmit = (e, search = query) => {
      e.preventDefault();
      if (search.length < 1) return;
      navigate(
        `/search-results?filter=faqs&searchQuery=${sanitizeHtml(search)}`,
      );
    };

    const focusOutsideOfSearch = useCallback(event => {
      const { keyCode } = event;
      if (keyCode === 9) {
        if (event.target.classList.contains('searchable-marker')) {
          return;
        }
        setOpen(false);
      }
    }, []);

    const clickOutsideOfSearch = useCallback(event => {
      if (event.target.classList.contains('searchable-marker')) {
        return;
      }
      setOpen(false);
    }, []);

    useEffect(() => {
      if (window) {
        window.addEventListener('keyup', focusOutsideOfSearch);
        window.addEventListener('click', clickOutsideOfSearch);
      }
      return () => {
        window.removeEventListener('keyup', focusOutsideOfSearch);
        window.removeEventListener('click', clickOutsideOfSearch);
      };
    }, [focusOutsideOfSearch]);

    return (
      <SearchInput
        id="faq-search"
        className={className}
        type={type}
        placeholder={placeholder}
        value={query}
        open={open}
        setOpen={setOpen}
        predictiveSearch={predictiveSearch}
        onSubmit={formSubmit}
        onChange={event => {
          setQuery(event.target.value);
        }}
      >
        {predictiveSearch && open && (
          <PredictiveSearchContainer
            className={`no-bullets 
              ${predictiveSearchClass} 
              searchable-marker`}
          >
            {results
              .map(({ id: key_id, title }) => {
                return (
                  <li key={key_id}>
                    <Link
                      className="searchable-marker"
                      to={`/search-results?filter=faqs&searchQuery=${sanitizeHtml(
                        title,
                      )}`}
                      state={{ open, setOpen }}
                    >
                      {ReactHtmlParser(title)}
                    </Link>
                  </li>
                );
              })
              .filter((_, i) => i <= 4)}
          </PredictiveSearchContainer>
        )}
      </SearchInput>
    );
  };
  FAQSearch.propTypes = {
    className: PropTypes.string,
    predictiveSearchClass: PropTypes.string,
    predictiveSearch: PropTypes.bool,
    type: PropTypes.string,
    placeholder: PropTypes.string,
  };
  return FAQSearch;
};

export default withFAQSearch(SearchBar);
